import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import { PaginationResult } from '../core/pagination';
import { Monitor } from '../models';

@Injectable({ providedIn: 'root' })
export class MonitoringApiService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = `${inject(API_CLIENT_CONFIG).apiBaseUrl}/api/admin/BackofficeMonitors`;

  getMonitorings(options?: {
    regions?: string[];
    cities?: string[];
    skip?: number;
    take?: number;
  }) {
    let params = new HttpParams();

    if (options?.regions) {
      params = params.append('regions', options.regions.join(','));
    }

    if (options?.cities) {
      params = params.append('cities', options.cities.join(','));
    }

    if (options?.skip !== null && options?.skip !== undefined) {
      params = params.append('skip', options.skip);
    }

    if (options?.take !== null && options?.take !== undefined) {
      params = params.append('take', options.take);
    }

    return this.http.get<PaginationResult<Monitor>>(this.baseUrl, {
      params,
    });
  }

  getMonitoringHistory(options?: {
    regions?: string[];
    cities?: string[];
    email?: string;
    skip?: number;
    take?: number;
  }) {
    let params = new HttpParams();

    if (options?.regions) {
      params = params.append('regions', options.regions.join(','));
    }
    if (options?.cities) {
      params = params.append('cities', options.cities.join(','));
    }

    if (options?.skip !== null && options?.skip !== undefined) {
      params = params.append('skip', options.skip);
    }

    if (options?.take !== null && options?.take !== undefined) {
      params = params.append('take', options.take);
    }

    return this.http.get<PaginationResult<Monitor>>(
      `${this.baseUrl}/history`,
      {
        params,
      },
    );
  }

  createMonitoring(request: { contractingAuthorityId: string; link: string }) {
    return this.http.post<Monitor>(this.baseUrl, request);
  }
}
